export const blackListCategoryNames = {
  rateCodeFull: 'Rate code',
  rateCodeStartsWith: 'Rate code',
  convertedPhoneNumber: 'Converted phone',
  invitedPhoneNumber: 'Invited phone',
  convertedEmailDomain: 'Converted email domain',
  convertedEmailAddress: 'Converted email',
  invitedEmailDomain: 'Invited email domain',
  invitedEmailAddress: 'Invited email',
  trackingInfoFull: 'Tracking info',
  trackingInfoStartingWith: 'Tracking info',
  convertedAddress: 'Converted address',
  invitedAddress: 'Invited address'
}

export const directBlacklistCategories = {
  rateCodeFull: 'Rate code',
  rateCodeStartsWith: 'Rate code starts with',
  trackingInfoFull: 'Tracking info',
  trackingInfoStartingWith: 'Tracking info starts with',
  convertedEmailDomain: 'Email domain',
  convertedPhoneNumber: 'Phone number',
  marketCodeFull: 'Market code'
}

export const hotelDetailsBlacklistCategories = {
  ...blackListCategoryNames,
  ...directBlacklistCategories,
  phoneNumber: 'Phone'
}

export const conversionKeysToBlacklistKeys = {
  invitedFormattedAddress: 'invitedAddress',
  invitedPhoneNumber: 'invitedPhoneNumber',
  invitedEmail: 'invitedEmailAddress',
  convertedFormattedAddress: 'convertedAddress',
  convertedPhoneNumber: 'convertedPhoneNumber',
  convertedEmail: 'convertedEmailAddress',
  convertedTrackingCode: 'trackingInfoFull',
  convertedRateCode: 'rateCodeFull',
  invitedEmailDomain: 'invitedEmailDomain',
  convertedEmailDomain: 'convertedEmailDomain'
}

export const blacklistKeysToConversionKeys = {
  invitedAddress: 'invitedFormattedAddress',
  invitedPhoneNumber: 'invitedPhoneNumber',
  invitedEmailAddress: 'invitedEmail',
  convertedAddress: 'convertedFormattedAddress',
  convertedPhoneNumber: 'convertedPhoneNumber',
  convertedEmailAddress: 'convertedEmail',
  trackingInfoFull: 'convertedTrackingCode',
  rateCodeFull: 'convertedRateCode',
  invitedEmailDomain: 'invitedEmailDomain',
  convertedEmailDomain: 'convertedEmailDomain'
}

export const behaviorNames = {
  noReach: `Never reach`
}

export const scopeNames = {
  businessLocation: 'This hotel',
  chain: 'This chain',
  global: 'Any hotel'
}

export const marketScopeNames = {
  businessLocation: 'This hotel',
  chain: 'This chain'
}

export const indieMarketScopeNames = {
  businessLocation: 'This hotel'
}

export const indieScopeNames = {
  businessLocation: 'This hotel',
  global: 'Any hotel'
}

export const blackListKeysConversionKeys = Object.keys(
  conversionKeysToBlacklistKeys
).reduce(
  (prev, current) => ({
    ...prev,
    [conversionKeysToBlacklistKeys[current]]: current
  }),
  {}
)

export const getCleanConversion = dC => {
  // business logic
  return {
    ...dC,
    convertedTrackingCode: dC.convertedTrackingCode
      ? dC.convertedTrackingCode.split(',')[0]
      : null,
    convertedEmail:
      dC.convertedEmail && dC.convertedEmail.match(/.+@.+/)
        ? dC.convertedEmail.toLowerCase()
        : null,
    invitedEmail: dC.invitedEmail ? dC.invitedEmail.toLowerCase() : null,
    convertedEmailDomain:
      dC.convertedEmail && dC.convertedEmail.match(/.+@.+/)
        ? `anything${dC.convertedEmail.match(/@.+/)[0].toLowerCase()}`
        : null,
    invitedEmailDomain:
      dC.invitedEmail && dC.invitedEmail.includes('@')
        ? `anything${dC.invitedEmail.match(/@.+/)[0].toLowerCase()}`
        : null,
    convertedFormattedAddress:
      dC.convertedFormattedAddress &&
      dC.convertedFormattedAddress.match(/\s?\d+(?=[^\d])/)
        ? dC.convertedFormattedAddress
        : null,
    invitedFormattedAddress:
      dC.invitedFormattedAddress && dC.invitedFormattedAddress.match(/\s?\d+(?=[^\d])/)
        ? dC.invitedFormattedAddress
        : null,
    invitedPhoneNumber:
      dC.invitedPhoneNumber && dC.invitedPhoneNumber.replace(/[^0-9]/g, '').length > 7
        ? dC.invitedPhoneNumber
        : null,
    convertedPhoneNumber:
      dC.convertedPhoneNumber && dC.convertedPhoneNumber.replace(/[^0-9]/g, '').length > 7
        ? dC.convertedPhoneNumber
        : null
  }
}

export const resentReasons = {
  CustomerRequestedChange: 'Customer has requested change',
  InvoiceIsFinalized: 'Invoice is finalized',
  PaymentFailed: 'Payment was failed',
  CustomerNotReceived: 'Invoice was not delivered',
  ContactChanged: 'Invoice was sent to the wrong person'
}
